export default __webpack_public_path__ + "static/media/progressive-app.9e056f72.svg";